import { Routes } from '@angular/router';
import { MainLayoutComponent } from './layout/main-layout.component';
import { HomeComponent } from './features/home/home/home.component';
import { TiendaComponent } from './features/catalog/tienda/tienda/tienda.component';
import { CategoriaComponent } from './features/catalog/categoria/categoria/categoria.component';
import { ProductoComponent } from './features/catalog/producto/producto/producto.component';
import { CartComponent } from './features/catalog/cart/cart/cart.component';
import { CheckoutComponent } from './features/catalog/checkout/checkout/checkout.component';
import { CotizarComponent } from './features/catalog/cotizar/cotizar/cotizar.component';
import { SoftwareHomeComponent } from './features/software/software-home/software-home/software-home.component';
import { LineComponent } from './features/software/line/line/line.component';
import { VersionComponent } from './features/software/version/version/version.component';
import { NosotrosComponent } from './features/corporativo/nosotros/nosotros/nosotros.component';
import { ContactoComponent } from './features/corporativo/contacto/contacto/contacto.component';


export const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      { path: '', component: HomeComponent },

      // Catálogo
      { path: 'tienda', component: TiendaComponent },
      { path: 'categoria/:slug', component: CategoriaComponent },
      { path: 'producto/:slug', component: ProductoComponent },
      { path: 'cart', component: CartComponent },
      { path: 'checkout', component: CheckoutComponent },
      { path: 'cotizar', component: CotizarComponent },

      // Software
      { path: 'software', component: SoftwareHomeComponent },
      { path: 'software/:line', component: LineComponent },
      { path: 'software/:line/:version', component: VersionComponent },

      // Corporativo
      { path: 'nosotros', component: NosotrosComponent },
      { path: 'contacto', component: ContactoComponent },
    ]
  },
  { path: '**', redirectTo: '' }
];
